import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonPrimaryComponent } from 'projects/components/button-primary/button-primary.component';
import { PhoneInputComponent } from 'projects/components/phone-input/phone-input.component';
import { AuthService } from 'projects/login/src/app/services/auth/auth.service';

@Component({
  selector: 'pay-login-lost-mfa-trigger',
  imports: [TranslatePipe, ReactiveFormsModule, PhoneInputComponent, ButtonPrimaryComponent],
  templateUrl: './lost-mfa-trigger.component.html',
})
export class LostMfaTriggerComponent {
  private readonly _router = inject(Router);
  private readonly _authService = inject(AuthService);

  phoneForm = new FormControl<string>('', { validators: [Validators.required, Validators.minLength(3)] });

  returnToLogin() {
    this._router.navigateByUrl('/').then();
  }

  submit() {
    if (this.phoneForm.invalid || !this.phoneForm.value) {
      return;
    }

    this._authService.mfaLost(this.phoneForm.value.replaceAll(' ', '')).subscribe({
      next: () => {
        this._router.navigateByUrl('/lost-2fa-verify').then();
      },
      error: () => {
        this._router.navigateByUrl('/lost-2fa').then();
      },
    });
  }
}
